// Loading component
import React from 'react';

const Loading = ({ message = 'Loading...', size = 'medium' }) => {
  const sizeClasses = {
    small: 'h-4 w-4',
    medium: 'h-8 w-8',
    large: 'h-12 w-12'
  };

  return (
    <div className="flex flex-col items-center justify-center p-8">
      <div className={`animate-spin rounded-full border-4 border-gray-200 border-t-primary-600 ${sizeClasses[size]}`}></div>
      <p className="mt-4 text-gray-600 text-sm">{message}</p>
    </div>
  );
};

export const LoadingSpinner = ({ className = '' }) => (
  <div className={`animate-spin rounded-full border-2 border-gray-200 border-t-primary-600 h-5 w-5 ${className}`}></div>
);

export default Loading;